export type SupervisiCssdHasil = "ya" | "tidak" | "na" | null;

export type SupervisiCssdKategori =
  | "pengiriman-alat-kotor"
  | "alur"
  | "pengemasan-labeling"
  | "sterilisator"
  | "tempat-penyimpanan"
  | "pendistribusian"
  | "fasilitas-kebersihan";

export interface SupervisiCssdItem {
  id: number;
  kategori: SupervisiCssdKategori;
  item_key: string;
  item_label: string;
  urutan: number;
  hasil: SupervisiCssdHasil;
  masalah: string | null;
  rekomendasi: string | null;
}

export interface UserRef {
  id: number;
  nama: string | null;
}

export interface SupervisiCssd {
  id: number;
  nomor_formulir: string | null;
  tanggal_supervisi: string;
  waktu_mulai: string | null;
  waktu_selesai: string | null;

  supervisor_user_id: number;
  supervisor: UserRef | null;
  supervisor_jabatan: string | null;
  signed_supervisor: boolean;
  signed_supervisor_at: string | null;

  kepala_unit_user_id: number | null;
  kepala_unit: UserRef | null;
  kepala_unit_nama_manual: string | null;
  signed_kepala_unit: boolean;
  signed_kepala_unit_at: string | null;

  temuan_utama: string | null;
  rencana_tindak_lanjut: string | null;

  is_locked: boolean;
  items?: SupervisiCssdItem[];

  created_at: string;
  updated_at: string;
}

export const KATEGORI_LABEL: Record<SupervisiCssdKategori, string> = {
  "pengiriman-alat-kotor": "I.   Supervisi Pengiriman Alat Kotor",
  "alur": "II.  Supervisi Alur",
  "pengemasan-labeling": "III. Supervisi Pengemasan dan Labeling",
  "sterilisator": "IV.  Supervisi Sterilisator",
  "tempat-penyimpanan": "V.   Supervisi Tempat Penyimpanan Alat",
  "pendistribusian": "VI.  Supervisi Pendistribusian Alat",
  "fasilitas-kebersihan": "VII. Supervisi Fasilitas Lain dan Kebersihan",
};
